<script>
import api from "@/axios"
import Loader from "../components/loader"
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ProdutosLoteTable from './produtoslote-table'
import appConfig from "@/app.config"
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/produtos_anim.json'
import { produtosChart1, produtosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Produtos (Estoque)",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ProdutosLoteTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted produtos-list_0')
    console.log(getBaseUrl() + '_IMG')

    this.atualizaDataList()
    this.atualizaDataGraph()
  },
  data() {
    return {
      animationJson,
      title: 'Produtos (Estoque)',
      valorTotal: 0,
      items: [
        {
          text: 'WMS',
          href: '/',
        },
        {
          text: 'Produtos (Estoque)',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      produtosListPaged: null,
      prodsChart1: produtosChart1,
      prodsChart2: produtosChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      currentPage: 1,
      showModalEndereco: false,
      wmsTransfData: {},
      prodSaldoDispData: {},
      msgValidacaoTrans: null
    }
  },

  methods: {

    informouProduto() {
      console.log('informouProduto')
      console.log(this.wmsTransfData.produto)

      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.wmsTransfData.produto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.wmsTransfData.descprod = res.data[0].descricao
      })


      this.$refs.lote.focus()
    },


    informouLote(){
      console.log('informouLote')
      this.$refs.dtvalid.focus()

    },

    informouQtdTransf(){
      console.log('informouQtdTransf')
      this.$refs.novopalete.focus()
    },


    informouNovoPalete(){
      console.log('informouNovoPalete')

      api.get(`${getBaseUrl()}api/wmspalcod`, {
        params: {coddata: this.wmsTransfData.novopalete}
      }).then((res) => {
        console.log('then axios endwms')
        console.log(res.data)
        if (res.data[0]){
          this.wmsTransfData.novoendwms = res.data[0]['endereco']

          this.confirmarTransf()

        }
      })

      this.$refs.novopalete.focus()
    },


    informouNovoEndereco(){
      console.log('informouNovoEndereco')
      this.$refs.novopalete.focus()
    },


    informouDtValid(){
      console.log('informouDtValid')

      api.post(`${getBaseUrl()}api/prodtransf`, {
        wmsTransfData: this.wmsTransfData
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data.endwms)
        if (res.data[0]){
          this.prodSaldoDispData = res.data[0]
          this.wmsTransfData.qtdtransf = res.data[0].saldo
          this.$refs.qtdtransf.focus()
        } else {
          this.prodSaldoDispData = {}
          this.wmsTransfData.qtdtransf = 0
        }
      })

    },

    confirmarTransf(){
      console.log('confirmarTransf')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Confirmação de Transferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.wmsTransfData.idestoque = this.prodSaldoDispData.id

          api.post(`${getBaseUrl()}api/prodtransfconf`, {
            wmsTransfData: this.wmsTransfData
          }).then((res) => {

            console.log('then axios')
            console.log(res.data)

            if (res.data[0] === 'transferecia_realizada')  {

              this.prodSaldoDispData = {}
              this.wmsTransfData = {}
              this.$refs.produto.focus()
              this.msgValidacaoTrans = null
            } else {
              this.msgValidacaoTrans = res.data[0]
            }

          })
        }
      })
    },


    alterarEndereco(){
      console.log('alterarEndereco')
      this.showModalEndereco = true


    },

    onPageChange(){
      console.log('onPageChange')
      console.log(this.currentPage)
      this.atualizaDataList()
    },

    relatorio(){
      console.log('relatorio')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relprod01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_produtos_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    relCadExcel(){
      console.log('relCadExcel')
      this.loadingList = true
      api.get(`${getBaseUrl()}api/relprod02`).then((res) => {
        console.log(res.data)
        const data = res.data[0]
        const fileName = "exp_dados"
        const exportType = exportFromJSON.types.xls
        if (data) exportFromJSON({ data, fileName, exportType });
        this.loadingList = false
      })

    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.produtosListPaged
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/id?page=${this.currentPage}`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.produtosListPaged = res.data

        let vlrTotal = 0
        this.produtosListPaged.data.forEach((value) => {

          if (value.dtvalid){
            value.dtvalid_fmt = moment(value.dtvalid).format('DD/MM/YYYY')
          }

          vlrTotal = vlrTotal + (value.cmedio * value.saldo)
        })
        this.valorTotal = vlrTotal


        this.title = `(${this.produtosListPaged.total}) Produtos (Estoque)`
        this.loadingList = false

      });
    },

    atualizaDataGraph(){
      this.loadingGraph = false
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/produto`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
}
</script>

<template>
  <Layout>
    <span class="float-end" style="z-index: 1000; position: absolute; top: 70px; right: 200px;">
      <Vue3Lottie :animationData="animationJson" :height="150" :width="150" />
    </span>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                      <option value="F">Com Foto</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (C.Médio) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Ativos:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Inativos:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Saldo:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="relCadExcel"
                       href="javascript: void(0);">
                      Exportar Cadastro para Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="relatorio"
                       href="javascript: void(0);">
                      Relatório Produtos com Saldo
                    </a>

                  </div>

                </b-dropdown>
              </div>

              <div class="col-sm-2" >
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="alterarEndereco" >
                  <i class="mdi mdi-upload me-1"></i> Transferência
                </button>
              </div>

              <div class="col-sm-5">
                <div class="text-sm-end">

                  <router-link :to="`/produto/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Produto
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div v-if="!loadingList">
              <ProdutosLoteTable :produtosList="produtosListPaged.data"/>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">

                      <b-pagination
                          v-model="currentPage"
                          :total-rows="produtosListPaged.total"
                          @update:modelValue="onPageChange">
                      </b-pagination>

                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Grupos Destaque Ano</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="prodsChart1.series"
                :options="prodsChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Produtos Destaque Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="scatter"
                dir="ltr"
                :series="prodsChart2.series"
                :options="prodsChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>





    <b-modal size="lg"
             title="Transferência de Produto"
             v-model="showModalEndereco" centered hide-footer>

      <div class="col-md-12">

        <div class="row">

          <div class="col-md-6">
            <div class="mb-3">
              <label for="produto">Favor informar o produto</label>
              <input
                  id="produto"
                  ref="produto"
                  v-model="wmsTransfData.produto"
                  type="text"
                  class="form-control"
                  @keypress.enter="informouProduto"
                  placeholder="Enter para confirmar..."/>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="produtodesc">Produto</label>
              <input
                  id="produtodesc"
                  ref="produtodesc"
                  v-model="wmsTransfData.descprod"
                  type="text"
                  class="form-control"
                  :disabled="true"
                  placeholder="Produto"/>
            </div>
          </div>

        </div>


        <div class="row">

          <div class="col-md-6">
            <div class="mb-3">
              <label for="lote">Lote</label>
              <input
                  id="lote"
                  ref="lote"
                  v-model="wmsTransfData.lote"
                  type="text"
                  @keypress.enter="informouLote"
                  class="form-control"
                  placeholder="Lote de fabricação"/>
            </div>
          </div>


          <div class="col-md-6">
            <div class="mb-3">
              <label for="dtvalid">Data de validade</label>
              <input
                  id="dtvalid"
                  ref="dtvalid"
                  v-model="wmsTransfData.dtvalid"
                  type="date"
                  @keypress.enter="informouDtValid"
                  class="form-control"
                  placeholder="Data de validade"/>
            </div>
          </div>

        </div>

        <div class="row">



          <div class="col-sm-6">
            <label for="endwms">Endereço</label>
            <div class="position-relative">
              <input
                  id="endwms"
                  type="text"
                  v-model="prodSaldoDispData.endwms"
                  class="form-control"
                  :disabled="true"
                  placeholder="Endereço"/>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="palete">Palete</label>
              <input
                  id="palete"
                  ref="palete"
                  v-model="prodSaldoDispData.palete"
                  type="number"
                  :disabled="true"
                  class="form-control"
                  placeholder="Palete"/>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-6">
            <div class="mb-3">
              <label for="qtddisp">Quantidade Disponível</label>
              <input
                  id="qtddisp"
                  ref="qtddisp"
                  v-model="prodSaldoDispData.saldo"
                  type="number"
                  :disabled="true"
                  class="form-control"
                  placeholder="Quantidade Disponível"/>
            </div>
          </div>

          <div class="col-sm-6">
            <label for="qtdtransf">Quantidade Transferir</label>
            <div class="position-relative">
              <input
                  id="endwms"
                  type="number"
                  ref="qtdtransf"
                  v-model="wmsTransfData.qtdtransf"
                  @keypress.enter="informouQtdTransf"
                  class="form-control"
                  placeholder="Quantidade Transferir"/>
            </div>
          </div>

        </div>


        <div class="row">



          <div class="col-sm-6">
            <label for="novoendwms">Novo Endereço</label>
            <div class="position-relative">
              <input
                  id="novoendwms"
                  type="text"
                  v-model="wmsTransfData.novoendwms"
                  class="form-control"
                  @keypress.enter="informouNovoEndereco"
                  placeholder="Novo Endereço"/>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="novopalete">Novo Palete</label>
              <input
                  id="novopalete"
                  ref="novopalete"
                  v-model="wmsTransfData.novopalete"

                  type="number"
                  class="form-control"
                  placeholder="Novo Palete"/>
            </div>
          </div>

        </div>

        <div class="row">

          <b-alert  show dismissible variant="danger"  v-if="msgValidacaoTrans">
            <i class="mdi mdi-alert me-2"></i>
            {{ msgValidacaoTrans }}
          </b-alert>

        </div>



        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalEndereco = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button :disabled="!wmsTransfData.novoendwms || !prodSaldoDispData.saldo || prodSaldoDispData.saldo < wmsTransfData.qtdtransf"
                    type="submit" variant="success" class="ms-1" @click="confirmarTransf()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>

    </b-modal>

  </Layout>
</template>
